import React, {useState, useMemo, Profiler, useEffect} from 'react'
import MaestroRelationship from './MaestroRelationship';
// import './ReportResults.scss';
// import 'react-virtualized/styles.css';
// import {Column, Table as VirtualizedTable} from 'react-virtualized';
import { CSVLink } from "react-csv";
import { format } from 'date-fns'
// import { Parser, transforms, parse } from 'json2csv';
// import { json2csv, json2csvAsync } from 'json-2-csv';
import { SavePdf, ShowPdf } from "./SavePdf";
import { getReportPdfBlob } from '@utils/getReportPdfBlob';
import OverviewData from './OverviewData';
import OverviewStatDetail from './OverviewStatDetail';
// import { getAddress, getPreferredPhone } from '../helpers';
import ReportObject from './ReportObject';
import { handler } from '@utils/csvSchema';
import { authenticatedApi, apiUrl, getAccessToken } from 'api';
import { Box, Button, FormControl, FormLabel, IconButton, Input, Stack, Tab, Table, TabList, TabPanel, Tabs, Textarea, Tooltip, Typography } from '@mui/joy';
import toast from 'react-hot-toast';
import AbstractObjectRelationship from '@components/objects/AbstractObjectRelationship';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import { Error } from '@components/UnrecoverableError';

// https://github.com/react-csv/react-csv/issues/323
const CSVLinkWithRef = React.forwardRef((props, ref) => (
    <CSVLink
      ref={(c) => {
        ref(c?.link);
      }}
      {...props}
    />
));

const DataTabs = ({data}) => {
    return (
        <Tabs variant='solid' color='neutral'>
          <TabList>
            {data.map((tab, index) => (
              <Tab key={index}>{tab.label}</Tab>
            ))}
          </TabList>
          {/* <TabPanel> */}
            {data.map((tab, index) => (
              <TabPanel p={4} key={index}>
                {tab.render()}
              </TabPanel>
            ))}
          {/* </TabPanels> */}
        </Tabs>
      )
};


const mappedAggregates = (items) => {
    const labeled = {};
    items.map(entry => labeled[entry.value] = entry.label);
    return labeled;
}

const mappedCommunities = (communities) => {
    const labeledCommunities = {};
    communities.map(community => labeledCommunities[community.value] = community.label);
    return labeledCommunities;
}

const resultTypes = {
    'overview': {
        name: 'Overview',
        slug: 'overview',
        // columns: [],
        // columns are nested
    },
    'aggregate': {
        name: 'Reinvestment Statistics',
        slug: 'aggregates',
        // columns: []
    },
    'contact': {
        name: 'Contacts',
        slug: 'contacts',
        /*
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <MaestroRelationship type={'contact'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                },
            },
            {
                title: 'Email',
                cell: (row) => {
                    // todo: include email icon
                    return <>
                        {row.email && (
                            <Button as="a" href={`mailto:${row.email}`} size='xs' mr={3} leftIcon={<i className="icon-envelope"></i>} variant='solid'>
                                Email
                            </Button>
                        )}
                        <span>{row.email}</span>
                    </>
                },
            },
            {
                title: 'Phone',
                cell: (row) => {
                    return getPreferredPhone(row);
                },
            },
        ],
        */
    },
    'business': {
        name: 'Businesses',
        slug: 'businesses',
        /*
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <MaestroRelationship type={'business'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                },
            },
            {
                title: 'Address',
                cell: (row) => {
                    return getAddress(row);
                },
            },
            // hours
        ]
        */
    },
    'property': {
        name: 'Properties',
        slug: 'properties',
        /*
        columns: [
            {
                title: 'Address',
                cell: (row) => {
                    return <MaestroRelationship type={'property'} id={row.id} community={row.community.subdomain}>{row.address}</MaestroRelationship>
                },
            },
            {
                title: 'Units',
                cell: (row) => {
                    if(!row.hasOwnProperty('property_units')) {
                        return (<span>N/A</span>);
                    }

                    let commericalUnits = [];
                    let residentialUnits = [];

                    row.property_units.map((unit, index) => {
                        if(unit.residential) {
                            residentialUnits.push(unit);
                        } else {
                            commericalUnits.push(unit);
                        }
                    });

                    return (<>
                    {row.property_units.length === 0 && (<span>N/A</span>)}
                    {!(row.business_unit_names || row.residential_unit_names) && (<>
                        {commericalUnits.length > 0 && (<div>
                            <b>Commercial:</b> {commericalUnits.map((unit, index) => {
                                <Tooltip key={index} hasArrow title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                    {unit.unit}{index == row.property_units.length ? ',' : ''}
                                </Tooltip>
                            })}
                        </div>)}
                        {residentialUnits.length > 0 && (<div>
                            <b>Residential:</b> {residentialUnits.map((unit, index) => {
                                <Tooltip key={index} hasArrow title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                    {unit.unit}{index == row.property_units.length ? ',' : ''}
                                </Tooltip>
                            })}
                        </div>)}
                        {/*
                        {row.property_units.map((unit, index) => {
                            <Tooltip key={index} hasArrow title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                {unit.unit}{index == row.property_units.length ? ',' : ''}
                            </Tooltip>
                        })}
                        *\/}
                    </>)}
                    {row.business_unit_names && (
                        <span>
                            <b>Commercial:</b> {row.business_unit_names}
                        </span>
                    )}
                    {row.residential_unit_names && (
                        <span>
                            <b>Residential:</b> {row.residential_unit_names}
                        </span>
                    )}
                </>)}
            },
            {
                title: 'Owner',
                cell: (row) => {
                    return (<>
                        {row.owner && row.owner_type == 'App\\Models\\Contact' && (
                            <MaestroRelationship type='contact' id={row.owner.id} object={row.owner} community={row.community.subdomain}>{row.owner.name}</MaestroRelationship>
                        )}
                        {row.owner && row.owner_type == 'App\\Models\\Business' && (
                            <MaestroRelationship type='business' id={row.owner.id} object={row.owner} community={row.community.subdomain}>{row.owner.name}</MaestroRelationship>
                        )}
                        {!row.owner && (
                            <span>N/A</span>
                        )}
                    </>);
                }
            }
        ]
        */
    },
    'event': {
        name: 'Events',
        slug: 'events',
        /*
        columns: [
            //
        ],
        */
    },
    'workplan': {
        name: 'Work Plans',
        slug: 'work-plans',
        /*
        columns: [
            // name,
            // date
        ]
        */
    },
    'workplan-tasks': {
        name: 'Work Plan Tasks',
        slug: 'workplan-tasks',
        /*
        columns: [
            // name,
            // workplan,
            // date
        ]
        */
    },
    'volunteer-hours': {
        name: 'Volunteers',
        slug: 'volunteer',
        /*
        columns: [
            // name,
            // entry,
            // involvement,
            // notes,
            // hours
        ]
        */
    },
    'donation': {
        name: 'Donations',
        slug: 'donations',
        /*
        columns: [
            // donor,
            // amount,
            // date
        ]
        */
    },
    'opportunity': {
        name: 'Opportunities',
        slug: 'volunteer-opportunities',
        // columns: []
    },
};

// alternate spellings
resultTypes.contacts = resultTypes.contact;
resultTypes.workplans = resultTypes.workplan;
resultTypes['work-plan'] = resultTypes.workplan;
resultTypes['work-plans'] = resultTypes.workplan;
resultTypes.businesses = resultTypes.business;
resultTypes.properties = resultTypes.property;
resultTypes.events = resultTypes.event;
resultTypes.donations = resultTypes.donation;
// resultTypes.importers = resultTypes.importer;
resultTypes.opportunities = resultTypes.opportunity;
resultTypes['volunteer-opportunity'] = resultTypes.opportunity;
resultTypes['volunteer-opportunities'] = resultTypes.opportunity;


let mappedResultTypes = {...resultTypes};
/*
// not needed because we have the alternate spellings above
for (const [key, value] of Object.entries(resultTypes)) {
    console.log(value);
    mappedResultTypes[value.slug] = value;
}
*/
// resultTypes.map(resultType => mappedResultTypes[resultType.slug] = resultType);

const allDataAsCsv = (communities, result) => {
    const mapped = mappedCommunities(communities);
    let data = [];

    // const labeledCommunities = {};
    // communities.map(community => labeledCommunities[community.value] = community.label);
    // return labeledCommunities;

    // const communityCount = Object.entries(result).length;

    // const availableObjects = [];
    for(const [communitySubdomain, communityData] of Object.entries(result)) {
        // const communityName = mapped[communitySubdomain];

        data.push(...handler(mapped, communitySubdomain, communityData));
    }

    return new Promise((resolve, reject) => {
        resolve(data);
    });
};

const ResultTable = ({type, data, communityCount}) => {
    // return null; // TODO: fix performance issues with this
    const memoData = useMemo(() => data);

    return <ReportObject aggregate={{label: resultTypes[type].name, value: type}} item={data} communityCount={communityCount} />
};

// const ReportResults = ({communities, aggregates, reportInfo: reportInfoProp, changeReportInfo, result, searchTerms}) => {
const ReportResults = ({reportInfo: reportInfoProp, changeReportInfo, result}) => {
    const [savingReport, setSavingReport] = useState(false);
    const [reportLogo, setReportLogo] = useState(null);
    const [reportInfo, setReportInfo] = useState(reportInfoProp);
    const setReportInfoProp = (prop, val) => {
        reportInfo[prop] = val;
        setReportInfo({
            ...reportInfo,
        });
    }

    const [viewingStatistic, setViewingStatistic] = useState(null);
    const [csvData, setCsvData] = useState('');

    useEffect(() => {
        if(result.error) {
            return;
        }

        // todo: embed this logo in maestro itself instead of pulling from the website
        let defaultLogo = 'https://www.maestrocm.com/wp-content/uploads/2022/04/MM-Logo-2020-RGB.png';
        let logo = defaultLogo;
        let defaultLogoWidth = 1411
        let defaultLogoHeight = 430;
        const defaultLogoObject = {
            src: undefined,//`${apiUrl}proxy?url=${defaultLogo}`,
            width: defaultLogoWidth,
            height: defaultLogoHeight,
            aspectRatio: defaultLogoWidth/defaultLogoHeight,
        };

        if(result.options.communities.length === 1) {
            if(result.options.meta.logos.hasOwnProperty(result.options.communities[0].value)) {
                logo = result.options.meta.logos[result.options.communities[0].value];
            }
        } else {
            let hasSameConductorLogo = true;
            let conductorLogo = null;
            // check if each install is in the same condcutor
            for(const community of result.options.communities) {
                if(!result.options.meta.logos.hasOwnProperty(`conductor_${community.value}`)) {
                    hasSameConductorLogo = false;
                    break;
                }

                if(conductorLogo === null) {
                    conductorLogo = result.options.meta.logos[`conductor_${community.value}`];
                }

                if(conductorLogo !== result.options.meta.logos[`conductor_${community.value}`]) {
                    hasSameConductorLogo = false;
                break;
                }
            }

            if(hasSameConductorLogo && conductorLogo !== null) {
                logo = conductorLogo;
            }
        }

        if(logo === defaultLogo) {
            setReportLogo(defaultLogoObject);

            return;
        }

        let img = new Image();
        img.onload = function() {
            let width = img.naturalWidth;
            let height = img.naturalHeight;
            setReportLogo({
                src: `${apiUrl}proxy?url=${logo}`,
                width,
                height,
                aspectRatio: width/height,
            });
        }
        img.onerror = function() {
            setReportLogo(defaultLogoObject);
        };
        img.src = logo;

    }, [reportInfo]);

    if(result.error || result.debug) {
        return (
            <Error>
                There was an error returning your report.
                {/* <br/> */}
                {/* Please try again later or contact support if this issue persists. */}
            </Error>
        );
    }

    const { communities, aggregates, searchTerms, statsOnly } = result.options;

    // TODO: Allow sorting data by community
    const labeledCommunities = {};
    communities.map(community => labeledCommunities[community.value] = community.label);
    // console.log(labeledCommunities);

    let aggregateMasterOverview = {};
    let allResults = {};
    let firstResult = Object.entries(result)[0][1];

    // set "community" for all results, even if just a singular install
    for(const subdomain in result) {
        if(subdomain === 'options') continue;
        for(const resultType in result[subdomain]) {
            if(resultType !== 'aggregates') {
                if(!allResults.hasOwnProperty(resultType)) {
                    allResults[resultType] = [];
                }

                let resultsOfType = result[subdomain][resultType];
                /*
                for(const resultIndex in resultsOfType) {
                    resultsOfType[resultIndex].community = {
                        name: labeledCommunities[subdomain],
                        subdomain
                    };
                }
                */

                if(resultsOfType) {
                    allResults[resultType].push(...resultsOfType);
                }
            }
        }
    }

    // if(Object.keys(result).length > 1) {
    if(communities.length > 1) {
        for(const subdomain in result) {
            if(subdomain === 'options') continue;
            // console.log('looping subdomain', subdomain);

            for(const resultType in result[subdomain]) {
                // console.log('looping resultType', resultType);
                if(resultType !== 'aggregates') {
                    continue;
                }

                let community = {
                    name: labeledCommunities[subdomain],
                    subdomain
                };

                let communityAggregates = result[subdomain][resultType];

                /*
                if(communityIterator == 1) {
                    aggregateMasterOverview = communityAggregates;
                    continue;
                }
                */

                for(const aggregateKey in communityAggregates) {
                    const aggregateValue = communityAggregates[aggregateKey];

                    if(aggregateKey === 'businesses_by_type' || aggregateKey === 'properties_by_type') {
                        const keyMapping = {
                            businesses_by_type: 'business_type',
                            properties_by_type: 'property_type',
                        };

                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {};
                        }

                        for(const objKey in aggregateValue) {
                            const objVal = aggregateValue[objKey];
                            if(!aggregateMasterOverview[aggregateKey].hasOwnProperty(objKey)) {
                                aggregateMasterOverview[aggregateKey][objKey] = {
                                    [keyMapping[aggregateKey]]: objVal[keyMapping[aggregateKey]],
                                    count: 0,
                                    total: 0,
                                    percent: 0,
                                };
                            }

                            aggregateMasterOverview[aggregateKey][objKey].count += objVal.count;
                            aggregateMasterOverview[aggregateKey][objKey].total += objVal.total;

                            if(aggregateMasterOverview[aggregateKey][objKey].total > 0) {
                                let percent = aggregateMasterOverview[aggregateKey][objKey].count / aggregateMasterOverview[aggregateKey][objKey].total * 100;
                                aggregateMasterOverview[aggregateKey][objKey].percent = percent.toFixed(2);
                            }
                        }
                    }
                    else if(aggregateKey === 'businesses_relocated') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                in: 0,
                                out: 0,
                            };

                            aggregateMasterOverview[`${aggregateKey}_in`] = 0;
                            aggregateMasterOverview[`${aggregateKey}_out`] = 0;
                        }

                        if(Array.isArray(aggregateValue.in)) {
                            aggregateValue.in = aggregateValue.in?.[0] ?? 0;
                            aggregateValue.out = aggregateValue.out?.[0] ?? 0;
                        }

                        // make grouped data iterable
                        aggregateMasterOverview[aggregateKey].in += aggregateValue.in;
                        aggregateMasterOverview[aggregateKey].out += aggregateValue.out;
                        aggregateMasterOverview[`${aggregateKey}_in`] += aggregateValue.in;
                        aggregateMasterOverview[`${aggregateKey}_out`] += aggregateValue.out;

                        /*
                        if(typeof aggregateValue.in === 'number') {
                            aggregateValue.in = [aggregateValue.in];
                            aggregateValue.out = [aggregateValue.out];
                        }

                        aggregateMasterOverview[aggregateKey].in.push(...aggregateValue.in);
                        aggregateMasterOverview[aggregateKey].out.push(...aggregateValue.out);
                        aggregateMasterOverview[`${aggregateKey}_in`].push(...aggregateValue.in);
                        aggregateMasterOverview[`${aggregateKey}_out`].push(...aggregateValue.out);
                        */
                    }
                    else if(aggregateKey === 'employee_changes' || aggregateKey === 'total_employees') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                full_time: 0,
                                part_time: 0,
                                seasonal: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].full_time += aggregateValue.full_time;
                        aggregateMasterOverview[aggregateKey].part_time += aggregateValue.part_time;
                        aggregateMasterOverview[aggregateKey].seasonal += aggregateValue.seasonal;
                    }
                    else if(
                        aggregateKey === 'grants_received'
                        || aggregateKey === 'event_attendance'
                        || aggregateKey === 'public_investments'
                        || aggregateKey === 'improved_properties'
                        || aggregateKey === 'sold_properties'
                    ) {
                        const keyMapping = {
                            grants_received: 'grants',
                            event_attendance: 'events',
                            public_investments: 'investments',
                            improved_properties: 'improvements',
                            sold_properties: 'sales',
                        };
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                total: 0,
                                [keyMapping[aggregateKey]]: [],
                            };
                        }

                        aggregateMasterOverview[aggregateKey].total += aggregateValue.total;

                        // make grouped data iterable
                        if(typeof aggregateValue[keyMapping[aggregateKey]] === 'number') {
                            aggregateValue[keyMapping[aggregateKey]] = [aggregateValue[keyMapping[aggregateKey]]];
                        }

                        aggregateMasterOverview[aggregateKey][keyMapping[aggregateKey]].push(...aggregateValue[keyMapping[aggregateKey]]);
                    }
                    else if(aggregateKey === 'parking') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                public: {
                                    lot: 0, on_street: 0,
                                },
                                hourly: {
                                    lot: 0, on_street: 0,
                                },
                                handicapped: {
                                    lot: 0, on_street: 0,
                                },
                                leased: {
                                    lot: 0, on_street: 0,
                                },
                                private: {
                                    lot: 0, on_street: 0,
                                },
                            };
                        }

                        aggregateMasterOverview[aggregateKey].public.lot += aggregateValue.public.lot;
                        aggregateMasterOverview[aggregateKey].public.on_street += aggregateValue.public.on_street;
                        aggregateMasterOverview[aggregateKey].hourly.lot += aggregateValue.hourly.lot;
                        aggregateMasterOverview[aggregateKey].hourly.on_street += aggregateValue.hourly.on_street;
                        aggregateMasterOverview[aggregateKey].handicapped.lot += aggregateValue.handicapped.lot;
                        aggregateMasterOverview[aggregateKey].handicapped.on_street += aggregateValue.handicapped.on_street;
                        aggregateMasterOverview[aggregateKey].leased.lot += aggregateValue.leased.lot;
                        aggregateMasterOverview[aggregateKey].leased.on_street += aggregateValue.leased.on_street;
                        aggregateMasterOverview[aggregateKey].private.lot += aggregateValue.private.lot;
                        aggregateMasterOverview[aggregateKey].private.on_street += aggregateValue.private.on_street;
                    }
                    else if(aggregateKey === 'public_improvements') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                public_total: 0,
                                private_total: 0,
                                improvements: [],
                            };
                        }

                        aggregateMasterOverview[aggregateKey].public_total += aggregateValue.public_total;
                        aggregateMasterOverview[aggregateKey].private_total += aggregateValue.private_total;

                        // make grouped data iterable
                        if(typeof aggregateValue.improvements === 'number') {
                            aggregateValue.improvements = [aggregateValue.improvements];
                        }

                        aggregateMasterOverview[aggregateKey].improvements.push(...aggregateValue.improvements);
                    }
                    else if(aggregateKey === 'roi') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                roi: 0,
                                private: 0,
                                public: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].private += aggregateValue.private;
                        aggregateMasterOverview[aggregateKey].public += aggregateValue.public;

                        if(aggregateMasterOverview[aggregateKey].public > 0) {
                            let percent = aggregateMasterOverview[aggregateKey].private / aggregateMasterOverview[aggregateKey].public;
                            aggregateMasterOverview[aggregateKey].roi = percent.toFixed(2);
                        }
                    }
                    else if(aggregateKey === 'occupancy_rate') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                occupancy_rate: 0,
                                occupied_units: 0,
                                num_units: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].occupied_units += aggregateValue.occupied_units;
                        aggregateMasterOverview[aggregateKey].num_units += aggregateValue.num_units;

                        if(aggregateMasterOverview[aggregateKey].num_units > 0) {
                            let rate = aggregateMasterOverview[aggregateKey].occupied_units / aggregateMasterOverview[aggregateKey].num_units;
                            aggregateMasterOverview[aggregateKey].occupancy_rate = rate;
                        }
                    }
                    else if(aggregateKey === 'rent_per_square_foot') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                rent: 0,
                                total_rent: 0,
                                num_units: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].total_rent += aggregateValue.total_rent;
                        aggregateMasterOverview[aggregateKey].num_units += aggregateValue.num_units;

                        if(aggregateMasterOverview[aggregateKey].num_units > 0) {
                            let total = aggregateMasterOverview[aggregateKey].total_rent / aggregateMasterOverview[aggregateKey].num_units;
                            aggregateMasterOverview[aggregateKey].rent = total.toFixed(2);
                        }
                    }
                    else if(aggregateKey === 'transformational_strategies') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                total: 0,
                                met: 0,
                                rate: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].total += aggregateValue.total;
                        aggregateMasterOverview[aggregateKey].met += aggregateValue.met;

                        if(aggregateMasterOverview[aggregateKey].total > 0) {
                            let total = aggregateMasterOverview[aggregateKey].met / aggregateMasterOverview[aggregateKey].total;
                            aggregateMasterOverview[aggregateKey].rate = total.toFixed(2);
                        }
                    }
                    else if(aggregateKey === 'staff_volunteer_hours') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {
                                staff: 0,
                                volunteer: 0,
                            };
                        }

                        aggregateMasterOverview[aggregateKey].staff += aggregateValue.staff;
                        aggregateMasterOverview[aggregateKey].volunteer += aggregateValue.volunteer;
                    }
                    else if(typeof aggregateValue === 'object' && aggregateValue.hasOwnProperty('total')) {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = {total: 0};
                        }
                        aggregateMasterOverview[aggregateKey].total += aggregateValue.total;
                    }
                    else if(typeof aggregateValue === 'number') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = 0;
                        }
                        aggregateMasterOverview[aggregateKey] += aggregateValue;
                    }
                }

                /*
                for(const aggregateKey in communityAggregates) {
                    console.log('looping aggregateKey', aggregateKey);
                    const aggregateValue = communityAggregates[aggregateKey];

                    if(typeof aggregateValue === 'number') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = 0;
                        }

                        aggregateMasterOverview[aggregateKey] += aggregateValue;
                    } else if(typeof aggregateValue === 'object') {
                        if(!aggregateMasterOverview.hasOwnProperty(aggregateKey)) {
                            aggregateMasterOverview[aggregateKey] = aggregateValue;
                            // continue;
                        }

                        let obj = JSON.parse(JSON.stringify(aggregateMasterOverview[aggregateKey]));
                        console.log('obj', obj);

                        for(const nestedKey in aggregateValue) {
                            const nestedValue = aggregateValue[nestedKey];

                            if(typeof nestedValue === 'number') {
                                if(!obj.hasOwnProperty(nestedKey)) {
                                    obj[nestedKey] = 0;
                                }

                                obj[nestedKey] += nestedValue;
                            } else if(typeof nestedValue === 'object') {
                                if(Array.isArray(nestedValue)) {
                                    if(!obj.hasOwnProperty(nestedKey)) {
                                        obj[nestedKey] = [];
                                    }

                                    let objs = JSON.parse(JSON.stringify(nestedValue));
                                    if(objs.length && typeof objs[0] === 'object') {
                                        for(const objIndex in objs) {
                                            objs[objIndex].community = {
                                                name: labeledCommunities[subdomain],
                                                subdomain
                                            };
                                        }
                                    }

                                    // console.log(obj[nestedKey]);
                                    // console.log(objs);

                                    obj[nestedKey].push(...objs);
                                } else {
                                    if(!obj.hasOwnProperty(nestedKey)) {
                                        obj[nestedKey] = JSON.parse(JSON.stringify(nestedValue));
                                    } else {
                                        // todo: deep combine
                                        // obj[nestedKey] = nestedValue;

                                        let objs = JSON.parse(JSON.stringify(nestedValue));
                                        for(const objKey in objs) {
                                            const subVal = objs[objKey];

                                            if(typeof subVal === 'number') {
                                                console.log(objKey, "0"+obj[nestedKey][objKey], "0"+subVal);
                                                if(objKey === 'percent1') {
                                                    obj[nestedKey][objKey] = obj[nestedKey]['count'] / obj[nestedKey]['total'] * 100;
                                                } else {
                                                    obj[nestedKey][objKey] += subVal;
                                                }
                                            } else if(typeof subVal === 'object') {
                                                if(nestedKey == 'properties' || nestedKey == 'properties_with_units' || nestedKey == 'properties_without_units') {
                                                    if(!Array.isArray(obj[nestedKey]) && Object.entries(obj[nestedKey]).length) {
                                                        obj[nestedKey] = [Object.values(obj[nestedKey])];
                                                    }

                                                    obj[nestedKey].push(Object.values(subVal));
                                                } else {
                                                    //
                                                    console.log(nestedKey, objKey, subVal);
                                                }
                                            }
                                        }

                                        // console.log(nestedKey, aggregateValue[nestedKey]);
                                    }
                                }
                            }

                            /*
                            for(const nestedValue of communityAggregates[aggregateKey][nestedKey]) {
                                // only get generic results
                                // if(typeof nestedValue !== 'object') {
                                    // obj[aggregateKey] = aggregateValue;
                                // }
                            }
                            *\/
                        }

                        aggregateMasterOverview[aggregateKey] = obj;
                    }

                    // console.log(typeof aggregateValue);
                    // console.log(aggregateValue);
                }
                */


                /*
                for(const aggregateKey in communityAggregates) {
                    let obj = {};
                    for(const aggregateValue of communityAggregates[aggregateKey]) {
                        // only get generic results
                        if(typeof aggregateValue !== 'object') {
                            obj[aggregateKey] = aggregateValue;
                        }
                    }
                }

                if(!Object.keys(aggregateMasterOverview).length) {
                    aggregateMasterOverview = {...result[subdomain][resultType]};
                } else {
                    // append
                }
                */
            }
        }
    } else {
        // allResults = firstResult;

        if(firstResult.hasOwnProperty('aggregates')) {
            aggregateMasterOverview = firstResult.aggregates;

            if(aggregateMasterOverview.hasOwnProperty('businesses_relocated')) {
                const { in: bizIn, out: bizOut } = aggregateMasterOverview.businesses_relocated;
                aggregateMasterOverview[`businesses_relocated_in`] = bizIn;
                aggregateMasterOverview[`businesses_relocated_out`] = bizOut;
            }
        }
    }

    // todo: sort results
    // console.log(allResults);

    /*
    for(const [subdomain, communityData] in Object.entries(result)) {
        console.log(subdomain);
    }
    */

    const shouldRenderPane = (responseKey) => {
        // todo: multi-community support (although technically this should work for multiple communities without looping through them all)
        return allResults/*Object.entries(result)[0][1]*/.hasOwnProperty(responseKey) && countForValue(responseKey) > 0;
    };

    const dataForValue = (responseKey) => {
        // todo: multi-community support
        return allResults/*Object.entries(result)[0][1]*/[responseKey];
    };

    const countForValue = (responseKey) => {
        return dataForValue(responseKey).length;
    };

    const hasResults = () => {
        return (
            shouldRenderPane('contacts') ||
            shouldRenderPane('businesses') ||
            shouldRenderPane('properties') ||
            shouldRenderPane('work-plans') ||
            shouldRenderPane('workplan-tasks') ||
            shouldRenderPane('donations') ||
            shouldRenderPane('volunteer-hours') ||
            shouldRenderPane('volunteer-opportunities')
        );
    }

    const statisticLabel = function(label) {
        // if(label === '')
        return label;
    }

    const canViewStatistic = function(aggregate, item)
    {
        let slug = aggregate.value;

        let statKeys = [
            'new_businesses',
            'closed_businesses',
            'not_for_profit',
            'improved_properties',
            'sold_properties',
            'new_properties',
            'lost_properties',
            'public_improvements',
            'public_investments',
            'events_held',
            'grants_received',
            'trainings_held',
            'businesses_relocated',
            'new_residential_units',
            'total_residential_units',
            'total_commercial_units',
        ]

        if(communities.length > 1) {
            statKeys.push('staff_volunteer_hours');
        }

        return statKeys.indexOf(slug) !== -1;

        /*
        return false;
        */

        /*
        // Not loaded
        if(!$scope.loadedReport.data || !$scope.loadedReport.data[slug])
        {
            return false;
        }
        */

        /*
        if(slug === 'total_residential_units') {
            return true;
        }

        // Total / "by type" stats don't have a box
        if(slug.match('total_') || slug.match('by_type'))
        {
            return false;
        }

        if(slug == 'businesses_relocated')
        {
            return Object.keys(item.in).length || Object.keys(item.out).length;
        }

        if(slug == 'assessed_market_value' || slug == 'transformational_strategies') {
            return false;
        }

        // generics
        if(item.hasOwnProperty('total') && Object.keys(item).length > 1) {
            return item.total > 0;
        }

        return item.length;
        */
    };

    const viewStatistic = function(aggregate, item)
    {
        if(communities.length === 1) {
            setViewingStatistic({aggregate, item});
        } else {
            setViewingStatistic({aggregate, result});
        }
    };

    let aggregatesByKey = mappedAggregates(aggregates);

    const hasAffectingSearchTerm = () => {
        for(const term of searchTerms) {
            if(!term.hasOwnProperty('object') || !term.object.hasOwnProperty('value')) {
                continue;
            }

            if(['contacts', 'businesses', 'properties', 'work-plans', 'overview'].indexOf( term.object.value) !== -1) {
                return true;
            }
        }

        return false;
    };

    // let aggregates = mappedAggregates()

    // todo: allow toggling viewing by community or by object
    const viewByPanes = [
        {
            label: 'View By Community',
            render: () => <>
                View By Community
            </>
        },
        {
            label: 'View By Object',
            render: () => <>
                View By Object
            </>
        },
    ];

    let panes = [
        {
            label: 'Overview',
            render: () => <>deleted</>
        }
    ];

    // const availableObjects = [];
    for(const [communitySubdomain, communityData] of Object.entries(result)) {
        for(const [dataKey, dataValue] of Object.entries(communityData)) {
            if(dataKey === 'aggregates') {
                continue;
            }
            // BEN: REMOVE THIS ONCE WE FIGURE OUT HOW TO KEEP IT FROM RE-RENDERING OTHER TABS
            // MIGHT NEED TO SEPARATE THE DATATABS INTO SEPARATE TABS
            // if(dataKey !== 'overview') {
                // continue;
            // }

            /*
            if(mappedResultTypes.hasOwnProperty(dataKey)) {
                panes.push({
                    label: mappedResultTypes[dataKey].name,
                    render: () => <ResultTable type={dataKey} data={dataValue} />
                });
            }
            */

            for(const [resultKey, resultValue] of Object.entries(resultTypes)) {
                if(resultValue.slug == dataKey) {
                    panes.push({
                        label: resultValue.name,
                        render: () => <ReportObject aggregate={{label: resultValue.name, value: resultValue.slug}} item={dataValue}/>
                        // render: () => <ResultTable type={resultKey} data={dataValue} />
                    });
                }
            }
        }
    }

    /*
    // BEN: RE-ENABLE THIS TO BUILD OUT SUPPORT FOR SHOWING COMMUNITY-SPECIFIC DATA
    for(const [key, value] of Object.entries(result)) {
        panes.push({
            label: mappedCommunities(communities)[key],
            render: () => (<>

            </>)
        });
    }
    */

    if(Object.keys(aggregateMasterOverview).length == 0 && !hasResults()) {
        return (
            <div className="wrapper report-message">
                <i className="icon-warning large"></i>
                <em>This search did not return any information.</em>
            </div>
        )
    }

    const saveReport = async () => {
        toast.loading('Saving... (This could take a minute', {
            id: 'saving-report'
        });
        setSavingReport(true);

        // TODO: FIGURE OUT IF WE'VE ALREADY SAVED IT OR NOT
        let requestFields = {
            // info needed for
            name: reportInfo.name,
            notes: reportInfo.description,
            save_report: true,

            searches: result.options.request,
        };

        let formData = new FormData();
        for (var key in requestFields) {
            if(typeof requestFields[key] === 'object') {
                formData.append(key, JSON.stringify(requestFields[key]));
            } else {
                formData.append(key, requestFields[key]);
            }
        }

        if(firstResult.aggregates && Object.keys(firstResult.aggregates).length > 0) {
            const blob = await getReportPdfBlob({aggregates, aggregateMasterOverview, result, reportInfo: {...reportInfo, statsOnly, logo: reportLogo}});
            // var blob = new Blob([content], { type: "text/xml"});
            formData.append("file", blob);
        }

        const endpoint = window.location.hostname.indexOf('conductor') !== -1 ? 'conductor-reports' : 'reports';
        /*
        authenticatedApi.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        */

        // fetch(endpoint, )
        // we're passing multipart form data so we just do it with fetch

        //'Content-Type': 'multipart/form-data'

        const performSave = fetch(`${apiUrl}${endpoint}`, {
            method: 'post',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
                'Accept': 'application/json',
                // 'Content-Type': 'application/json',
            },
            body: formData,
        });

        toast.promise(performSave, {
            loading: 'Saving... (This could take a minute)',
            success: `The report was saved!`,
            error: 'There was an error saving the report.',
        }, {
            id: 'saving-report'
        });

        performSave.finally(() => {
            setSavingReport(false);
        });
    };

    return (<>

        {/*
        <ShowPdf
            aggregates={aggregates}
            result={result}
            aggregateMasterOverview={aggregateMasterOverview}
            reportInfo={{...reportInfo, statsOnly, logo: reportLogo}}
        />
        */}

        <Tabs defaultValue={'overview'}>
          <TabList>
            <Tab value='overview'>Overview</Tab>
            {shouldRenderPane('contacts') && <Tab value='contacts'>Contacts ({countForValue('contacts')})</Tab>}
            {shouldRenderPane('businesses') && <Tab value='businesses'>Businesses ({countForValue('businesses')})</Tab>}
            {shouldRenderPane('properties') && <Tab value='properties'>Properties ({countForValue('properties')})</Tab>}
            {shouldRenderPane('work-plans') && <Tab value='work-plans'>Work Plans ({countForValue('work-plans')})</Tab>}
            {shouldRenderPane('workplan-tasks') && <Tab value='workplan-tasks'>Work Plan Tasks ({countForValue('workplan-tasks')})</Tab>}
            {shouldRenderPane('donations') && <Tab value='donations'>Donations ({countForValue('donations')})</Tab>}
            {shouldRenderPane('volunteer-hours') && <Tab value='volunteer-hours'>Volunteer Hours ({countForValue('volunteer-hours')})</Tab>}
            {shouldRenderPane('volunteer-opportunities') && <Tab value='volunteer-opportunities'>Volunteer Opportunities ({countForValue('volunteer-opportunities')})</Tab>}
            {/*
            {panes.map((tab, index) => (
              <Tab key={index}>{tab.label}</Tab>
            ))}
            */}
          </TabList>
          {/* <TabPanels> */}
            <TabPanel p={4} value='overview'>
                <Stack flexDirection={'row'} gap={2}>
                {firstResult.aggregates && Object.keys(firstResult.aggregates).length > 0 && (

                <AbstractObjectRelationship title="Reinvestment Statistics" sx={{flexBasis: '40%'}}>
                    {/* <Box p={2}> */}

                        <Table
                        stripe="even"
                        sx={{
                            tableLayout: 'auto',
                            'tbody tr': {
                                position: 'relative',
                            },
                            'tbody tr th': {
                                // position: 'sticky',
                                // top: 0,
                                verticalAlign: 'top',
                            },
                            'tbody tr:nth-of-type(2n) th': {
                                backgroundColor: 'var(--TableRow-stripeBackground, var(--joy-palette-background-level2))',
                            },
                            '.action-cell': {
                                width: '40px',
                            }
                        }}
                        >
                            <tbody>
                            {(hasAffectingSearchTerm() || statsOnly === false) && (
                                <tr>
                                    <td colSpan="3">
                                        {statsOnly === false && <Typography fontSize={'md'}>Click on a statistic below to get a detailed overview.</Typography>}
                                        {hasAffectingSearchTerm() && <>
                                            {/* <br/> */}
                                            {(!aggregatesByKey.hasOwnProperty('roi') || (aggregatesByKey.hasOwnProperty('roi') && Object.keys(aggregatesByKey).length > 1)) && (
                                                <Typography fontSize={'sm'} style={{display: 'block'}}><sup>†</sup> Statistic is affected by search filters</Typography>
                                            )}
                                            {aggregatesByKey.hasOwnProperty('roi') && (
                                                <Typography fontSize={'sm'} style={{display: 'block'}}><sup>§</sup> ROI is likely skewed. When applying search filters, private investment changes but public does not.</Typography>
                                            )}
                                        </>}

                                    </td>
                                </tr>
                            )}
                            {aggregates.map((aggregate, aggregateIndex) => {
                                if(!aggregateMasterOverview.hasOwnProperty(aggregate.value)) {
                                    return null;
                                }

                                return (
                                    <tr key={aggregateIndex}>
                                        <th scope="row" style={{/*width: '20ch', */whiteSpace: 'break-spaces'}}>
                                            {aggregate.label === 'Transformational Strategy Goals Met' ? <>Transformational Strategy<br/>Goals Met</> : aggregate.label}{hasAffectingSearchTerm() && aggregate.affected_by_filters && (<>
                                            {aggregate.value !== 'roi' && <Tooltip title={'Statistic is affected by search filters'}><Typography sx={{display: 'inline-block', position: 'relative', top: -2, left: 1}}>†</Typography></Tooltip>}
                                            {aggregate.value === 'roi' && <Tooltip title={'Statistic may be skewed'}><Typography sx={{display: 'inline-block', position: 'relative', top: -2, left: 1}}>§</Typography></Tooltip>}
                                        </>)}</th>
                                        <td>
                                            <OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} />
                                        </td>
                                        <td className="action-cell">
                                            {statsOnly === false && canViewStatistic(aggregate, aggregateMasterOverview[aggregate.value]) && (
                                                <Tooltip title={'View Details'}>
                                                    <IconButton
                                                        color="neutral"
                                                        variant="outlined"
                                                        size="sm"
                                                        sx={{
                                                            '--IconButton-size': '1.5rem',
                                                            bgcolor: 'background.surface',
                                                            verticalAlign: 'sub',
                                                            // ml: 0.5,
                                                            'svg': {
                                                                width: '1.05rem',
                                                                height: '1.05rem',
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            viewStatistic(aggregate, aggregateMasterOverview[aggregate.value])
                                                        }}
                                                    >

                                                        <LoginRoundedIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}

                            </tbody>
                        </Table>
                        {/* </Box> */}
                    </AbstractObjectRelationship>
                )}

                <Stack gap={2} sx={{flex: 1}}>
                <AbstractObjectRelationship title="Report Info">
                    <Box p={2}>
                        <FormControl>
                            <FormLabel htmlFor='name'>Name</FormLabel>
                            {/* <Checkbox label="asdfdd" /> */}
                            <Input
                                id='name'
                                type='text'
                                value={reportInfo.name}
                                // onChange={event => console.log(event)}
                                onChange={(event) => {/*console.log(event);*/setReportInfoProp('name', event.target.value)/* reportInfo.name = event.target.value; setReportInfo(reportInfo)*/}}
                                required
                            />
                            {/* <FormHelperText>We'll never share your email.</FormHelperText> */}
                        </FormControl>
                        <FormControl sx={{pt: 2}}>
                            <FormLabel htmlFor='description'>Description / Narrative</FormLabel>
                            <Textarea
                                id='description'
                                type='text'
                                value={reportInfo.description}
                                onChange={(event) => {setReportInfoProp('description', event.target.value) /*reportInfo.description = event.target.value; setReportInfo(reportInfo)*/}}
                                required
                            />
                            {/* <FormHelperText>We'll never share your email.</FormHelperText> */}
                        </FormControl>

                        <Box mt={3}>
                            <Stack direction={'row'} spacing={3}>
                            {searchTerms && Object.keys(searchTerms).length > 0 && (
                                <Button
                                    color="neutral"
                                    variant="outlined"
                                    size="sm"
                                    component={CSVLinkWithRef}
                                    data={csvData}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                        //const [csvData, setCsvData] = useState('');
                                        allDataAsCsv(communities, result).then(data => {
                                            // setCsvData(data.replaceAll('undefined', ''));
                                            setCsvData(data);
                                            // console.log(csvData);
                                            done(true);
                                        }).catch(() => done(false));
                                    }}
                                    filename={`Maestro Report ${format(new Date(), 'MM_dd_yyyy')}.csv`}
                                    className="btn btn-primary"
                                    target="_blank"
                                >
                                    {/* Download all as .csv */}
                                    Download CSV
                                </Button>
                            )}

                            {/*
                            <CSVLink
                                data={allDataAsCsv(communities, result)}
                                filename={`Maestro Report ${format(new Date(), 'MM_dd_yyyy')}.csv`}
                                className="btn btn-primary"
                                target="_blank"
                            >
                                Download all as .csv
                            </CSVLink>
                            */}

                            {firstResult.aggregates && Object.keys(firstResult.aggregates).length > 0 && (
                            <SavePdf
                                aggregates={aggregates}
                                result={result}
                                aggregateMasterOverview={aggregateMasterOverview}
                                reportInfo={{...reportInfo, statsOnly, logo: reportLogo}}
                            />
                            )}

                            <Button
                                type="button"
                                onClick={() => {
                                    saveReport();
                                }}
                                disabled={savingReport}
                                loading={savingReport}
                                startDecorator={<SaveRoundedIcon/>}
                                sx={{
                                    ml: 'left',
                                }}
                            >
                                Save
                            </Button>
                            </Stack>
                        </Box>
                    </Box>
                </AbstractObjectRelationship>

                {viewingStatistic !== null && (
                    <OverviewStatDetail {...viewingStatistic} communities={mappedCommunities(communities)} />
                )}
                </Stack>

                </Stack>
            </TabPanel>


            {shouldRenderPane('contacts') && <TabPanel value='contacts'><ResultTable type={'contacts'} data={dataForValue('contacts')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('businesses') && <TabPanel value='businesses'><ResultTable type={'businesses'} data={dataForValue('businesses')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('properties') && <TabPanel value='properties'><ResultTable type={'properties'} data={dataForValue('properties')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('work-plans') && <TabPanel value='work-plans'><ResultTable type={'work-plans'} data={dataForValue('work-plans')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('workplan-tasks') && <TabPanel value='workplan-tasks'><ResultTable type={'workplan-tasks'} data={dataForValue('workplan-tasks')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('donations') && <TabPanel value='donations'><ResultTable type={'donations'} data={dataForValue('donations')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('volunteer-hours') && <TabPanel value='volunteer-hours'><ResultTable type={'volunteer-hours'} data={dataForValue('volunteer-hours')} communityCount={communities.length} /></TabPanel>}
            {shouldRenderPane('volunteer-opportunities') && <TabPanel value='volunteer-opportunities'><ResultTable type={'opportunities'} data={dataForValue('volunteer-opportunities')} communityCount={communities.length} /></TabPanel>}

        </Tabs>
        {/* <DataTabs data={panes} /> */}
    </>)

}

export default ReportResults;
